<template>
    <div class="link-text-component" :style="styles">
        <nuxt-link :to="getInternalLink(blok.link)" class="link" external>
            {{ blok.linkText }}
        </nuxt-link>
        <rich-text :content="blok.text" />
    </div>
</template>

<script setup lang="ts">
import type { ILinkTextConfig } from '@nuxt-monorepo/ui/types/components/LinkText';
import { getInternalLink } from '@nuxt-monorepo/ui/utils/internalLinking';

const props = defineProps<{ blok: ILinkTextConfig }>();

const { render } = useStoryblokRichText({});
const richText = (content: any) => {
    return render(content.content);
};

const styles = computed(() => ({
    '--link-align': props.blok.LinkAlign || null,
    '--text-align': props.blok.TextAlign || null,
}));
</script>

<style lang="postcss" scoped>
.link-text-component {
    @apply flex flex-col;
}
.link {
    @apply w-max;
    align-self: var(--link-align);
}
.text {
    text-align: var(--text-align);
}
</style>
